<template>
  <v-navigation-drawer
    v-model="template.panel_left"
    absolute
    temporary
    width="100%"
    :src="instance.theme.suppliers_background_image"
  >
    <v-list dark color="black">
      <v-list-item>
        <v-list-item-avatar>
          <v-btn icon @click="template.panel_left = false">
            <v-icon x-large>fa-light fa-xmark</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-title class="text-h6 font-weight-black">{{ supplier.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-container fluid class="overlay-menu">

    <v-list dark>

        <v-list-item @click="execMiDireccion()" v-if="service === 'delivery'">
          <v-list-item-avatar  @click="execMiDireccion()">
            <v-btn icon>
              <v-icon large>fa-light fa-location-dot</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black" v-html="$t('service.location.my_direcction')"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="1===2">
          <v-list-item-avatar>
            <v-btn icon>
              <v-icon large>fa-light fa-phone</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-title class="text-h6 font-weight-black" v-html="$t('common.support_label')"></v-list-item-title>
        </v-list-item>

        <v-divider class="pa-5"></v-divider>
        <v-list-item v-if="supplier.service_delivery" @click="execDelivery()">
          <v-list-item-avatar>
            <v-btn icon @click="execDelivery()">
              <v-icon small>fa-light fa-moped</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black" v-if="instance.labels_buttons.delivery.toString().length > 0">{{ instance.labels_buttons.delivery}}</v-list-item-title>
            <v-list-item-title class="text-h6 font-weight-black" v-else>
              <span>
                🏍️ {{ getLabels('delivery_title') }}
              </span>>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="supplier.service_take_away" @click="execTakeAway()">
            <v-list-item-avatar>
              <v-btn icon  @click="execTakeAway()">
                <v-icon small>fa-light fa-store</v-icon>
              </v-btn>
            </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black" v-if="instance.labels_buttons.take_away.toString().length > 0">{{ instance.labels_buttons.take_away }}</v-list-item-title>
            <v-list-item-title class="text-h6 font-weight-black" v-else>{{ $t('service.select_popup.take_away_title', {'category': instance.category_establishment}) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="supplier.service_table" @click="execMenuDigital()">
          <v-list-item-avatar>
            <v-btn icon @click="execMenuDigital()">
              <v-icon small>fa-light fa-table-picnic</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black" v-if="instance.labels_buttons.on_table.toString().length > 0">{{ instance.labels_buttons.on_table }}</v-list-item-title>
            <v-list-item-title class="text-h6 font-weight-black" v-else>{{ $t('service.select_popup.on_table_title', {'category': instance.category_establishment}) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="supplier.service_book" @click="execBook()">
          <v-list-item-avatar>
            <v-btn icon>
              <v-icon small>fa-light fa-calendar-days</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black" v-if="instance.labels_buttons.book.toString().length > 0">{{ instance.labels_buttons.book }}</v-list-item-title>
            <v-list-item-title class="text-h6 font-weight-black" v-else>{{ $t('service.select_popup.book_title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      <v-list-item v-if="supplier.service_schedule" @click="execSchedule()">
        <v-list-item-avatar>
          <v-btn icon>
            <v-icon small>fa-light fa-calendar-days</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6 font-weight-black" >
            Programar domicilio
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

        <v-divider class="pa-6"></v-divider>

        <v-list-item two-line @click="openGoogleMap()">
          <v-list-item-avatar>
            <v-btn icon>
              <v-icon large>fa-light fa-location-dot</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-black">{{ supplier.description }}</v-list-item-title>
            <v-list-item-subtitle class="font-weight-black">{{ supplier.address }}</v-list-item-subtitle>
          </v-list-item-content>

        </v-list-item>

        <social-networks :instance="instance"/>

        <locale-switcher v-if="1===2"></locale-switcher>

      </v-list>

    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import LocaleSwitcher from "./LocaleSwitcher";
import socialNetworks from "../common/SocialNetworks"

export default {
  name: "PanelLeft",
  components: { LocaleSwitcher, socialNetworks },
  computed: {
    ...mapState('customer', ["instance", "supplier"]),
    ...mapState('template', ["template"]),
    ...mapState('order', [ "onTablePurchase", "service"]),
    ...mapState('ontable', [ "tableId"]),
    ...mapGetters('customer',['getLabels']),

    validateLinksSocial() {
      return (
          this.instance.socialmedia.twitch.toString().length > 0 ||
          this.instance.socialmedia.youtube.toString().length > 0 ||
          this.instance.socialmedia.whatsapp.toString().length > 0 ||
          this.instance.socialmedia.instagram.toString().length > 0 ||
          this.instance.socialmedia.facebook.toString().length > 0
      );
    }
  },
  methods: {
    ...mapMutations('template', ["OpenLeftPanel","CloseLeftPanel"]),
    ...mapActions('order', ["setMenuDigital", "setDelivery", "setTakeAway", "setSchedule"]), 
    openGoogleMap(){
      let objCoordinates = [this.supplier.latitude,this.supplier.longitude]
      window.open("https://www.google.com/maps/search/?api=1&query=" + objCoordinates,"_blank")
    },
    execMiDireccion(){
      this.CloseLeftPanel();
      this.$router.push({ name: "my-location" });
    },
    execMenuDigital() {
      this.CloseLeftPanel();
      if (this.$route.name !== "OnTableMenuDigital") {
        let queryParams;
        if(this.tableId)  queryParams = { mesa: this.tableId && this.tableId}
        this.$router.push({
          name: "OnTableMenuDigital",
          params: { supplier_id: this.supplier.slug},
          query: queryParams
        });
      }
    },
    execDelivery() {
      this.CloseLeftPanel();
      if(this.instance.full_gps){
        this.$router.push({
          name: "Location"
        });
      }else{
        this.$router.push({
          name: "Delivery",
          params: { supplier_id: this.supplier.slug }
        });
      }
    },
    execTakeAway() {
      this.CloseLeftPanel();
      this.setTakeAway();
      if (this.$route.name !== "Home") {
        this.$router.push({
          name: "Home",
          params: { supplier_id: this.supplier.slug }
        });
      }
    },
    execBook() {
      this.CloseLeftPanel();
      if (this.$route.name !== "Book") {
        this.$router.push({
          name: "Book",
          params: { supplier_id: this.supplier.slug }
        });
      }
    },
    goHome() {
      if (this.$route.name !== "Home") {
        this.$router.push({
          name: "Home",
          params: { supplier_id: this.supplier.slug }
        });
      }
    },
    execSchedule() {
      this.setSchedule();
      this.CloseLeftPanel();
      if (this.$route.name !== "Home") {
        this.$router.push({
          name: "Home",
          params: { supplier_id: this.supplier.slug }
        });
      }
    }
  },
  mounted() {
    const root = document.getElementsByTagName("html")[0];
    root.classList.add("with-panel");
    root.classList.add("with-panel-left-reveal");
  },
  destroyed() {
    const root = document.getElementsByTagName("html")[0];
    root.classList.remove("with-panel");
    root.classList.remove("with-panel-left-reveal");
  }
};
</script>
<style scoped>
.overlay-menu{
background-color: rgba(0,0,0,0.3)!important;
}
</style>
